import { useParams, useNavigate } from 'react-router-dom';
import patterns from '../data/patterns';
import { getIcon, ArrowLeft } from '../components/Icons';
import CodeBlock from '../components/CodeBlock';

export default function PatternDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const pattern = patterns.find((p) => p.id === id);

  if (!pattern) {
    return (
      <div className="page-enter">
        <p>Pattern not found.</p>
        <button className="back-link" onClick={() => navigate('/')}>
          <ArrowLeft /> Back to home
        </button>
      </div>
    );
  }

  const Icon = getIcon(pattern.icon);

  return (
    <div className="page-enter">
      <div className="detail-header">
        <button className="back-link" onClick={() => navigate('/')}>
          <ArrowLeft /> Back to all patterns
        </button>
        <div className="icon-large">{Icon && <Icon />}</div>
        <h1 style={{ color: pattern.color }}>{pattern.title}</h1>
        <div className="subtitle">{pattern.subtitle}</div>
      </div>

      <Section color={pattern.color} title="What Is It?">
        <p>{pattern.description}</p>
      </Section>

      <Section color={pattern.color} title="Why It Matters for DevOps">
        <p>{pattern.why}</p>
      </Section>

      <Section color={pattern.color} title="Key Principles">
        <div className="principle-list">
          {pattern.principles.map((pr, i) => (
            <div key={i} className={`principle-card page-enter stagger-${i + 1}`}>
              <h4 style={{ color: pattern.color }}>{pr.name}</h4>
              <p>{pr.desc}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section color={pattern.color} title="DevOps Example">
        <CodeBlock code={pattern.devopsExample} title={`${pattern.id}-example`} />
      </Section>
    </div>
  );
}

/** Small wrapper to avoid repeating section markup. */
function Section({ color, title, children }) {
  return (
    <div className="section-block">
      <h2>
        <span className="section-bar" style={{ background: color }} />
        {title}
      </h2>
      {children}
    </div>
  );
}
